import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { BookOfAccountsMenuList, NavMenus, SettingMenuList, operationMenuList } from './model/menuList';
import { Router } from '@angular/router';
import { DecryptPipe } from '../../../../app/auth/_services/encrypt-decrypt.pipe';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../_services/app.service';
import { collectExternalReferences } from '@angular/compiler';

@Component({
  selector: 'app-menu-list',
  templateUrl: './menu-list.component.html',
  styleUrls: ['./menu-list.component.scss']
})
export class MenuListComponent implements OnInit {
  operationsMenuList: any = operationMenuList;
  bookOfAccountsMenuList: any = BookOfAccountsMenuList;
  settingMenuList: any = SettingMenuList;
  NavMenus: any = NavMenus;

  whs_IsWarehouseMenu_Flag: any = false;
  @ViewChild('subMenu') subMenu: any;
  @ViewChild('subMenu') actualTarget: any;
  @Output() onClose = new EventEmitter<any>();
  searchFieldDetails: any = {
    placeholder: 'Search',
    type: 'text',
    isSearchBox: true
  };
  constructor(private router: Router,
    private decryptpipe: DecryptPipe,
    private cookieService: CookieService,
    private _appService: appService,
    private toaster: ToastrService,
    private cdr: ChangeDetectorRef
  ) { }

  UserId: any;
  IsKyc: any;
  filteredNavMenus = [];
  ngOnInit() {
    this.UserId = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("UserId"))
    );
    // console.log("NewHomeUserid", this.UserId);
    this.CheckKYC();
    // this.Get_whs_IsWarehouseMenu_Flag();

    // this.filteredNavMenus = NavMenus.filter(menu => {
    //   return menu.list.some(item => {
    //     if (item.childMenuList && Array.isArray(item.childMenuList)) {
    //       return item.childMenuList.some(child =>
    //         child.rightcode && child.screencode &&
    //         this.CheckHasRight(child.rightcode, child.screencode)
    //       );
    //     }
    //     return false;
    //   });
    // });

    this.filteredNavMenus = NavMenus.filter(menu => {
      const list = menu.list as any[];
      return list.some(item => {
        if (item.childMenuList && Array.isArray(item.childMenuList)) {
          return item.childMenuList.some(child =>
            child.rightcode && child.screencode &&
            this.CheckHasRight(child.rightcode, child.screencode)
          );
        }
        return false;
      });
    });

    console.log('filteredNavMenus:', this.filteredNavMenus);

  }

  RoleRightsData: any = [];
  public CheckHasRight(RightCode, ScreenCode): Boolean {
    this.RoleRightsData = JSON.parse(localStorage.getItem("rights_assigned"));
    var flag: Boolean = true;
    let UserRole = this.decryptpipe.transform(JSON.parse(this.cookieService.get("SetUserRole")));
    if (UserRole.match("Admin")) {
      return true;
    }
    this.RoleRightsData.forEach((element) => {
      if (element.ScreenCode == ScreenCode && element.RightCode == RightCode) {
        if (element.RoleScreenRightsId == null) {
          flag = false;
        }
      }
    });
    return flag;
  }

  CheckKYC() {
    // 
    let Userid = this.UserId;
    this._appService
      .GetById("OrdersByVehicle", "checkTransporter", Userid).subscribe((response) => {
        this.IsKyc = response[0].IsKyc;
        this.updateMenuListBasedOnKYC();
        this.cdr.detectChanges();
        //console.log("Newhome KYC Flag", this.IsKyc);
      }),
      (error) => {
        console.log(error);
      }
  }

  updateMenuListBasedOnKYC() {
    if (this.IsKyc === false) {
      // Create a new menu list with 'Booking' removed
      this.NavMenus = this.NavMenus.map(nav => ({
        ...nav,
        list: nav.list.map(column => ({
          ...column,
          childMenuList: column.childMenuList.filter(item => item.label !== 'Booking')
        }))
      }));
    }
  }



  naviageToRoute(url) {
    this.router.navigateByUrl(url);
    this.onCloseClick();
  }

  onCloseClick() {
    this.onClose.emit();
  }

  onSearch(value: any) {
  }

  shouldDisplaySettings(): boolean {
    for (let column of this.settingMenuList) {
      for (let menu of column.childMenuList) {
        if (this.CheckHasRight(menu.rightcode, menu.screencode)) {
          return true;
        }
      }
    }
    return false;
  }
  shouldDisplayOperations(): boolean {
    for (let column of this.operationsMenuList) {
      for (let menu of column.childMenuList) {
        if (this.CheckHasRight(menu.rightcode, menu.screencode)) {
          return true;
        }
      }
    }
    return false;
  }
  shouldDisplayBooks(): boolean {
    for (let column of this.bookOfAccountsMenuList) {
      for (let menu of column.childMenuList) {
        if (this.CheckHasRight(menu.rightcode, menu.screencode)) {
          return true;
        }
      }
    }
    return false;
  }

  get filteredSettingMenuList(): any[] {
    return this.settingMenuList.filter(column => this.hasVisibleChildItems(column));
  }

  get filteredOperationsMenuList(): any[] {
    return this.operationsMenuList.filter(column => this.hasVisibleChildItems(column));
    // this.whs_IsWarehouseMenu_Flag = JSON.parse(localStorage.getItem("whs_IsWarehouseMenu_Flag"));
    // return this.operationsMenuList.filter(column => this.hasVisibleChildItems(column)
    //   && (this.whs_IsWarehouseMenu_Flag == true || column.rowName != 'Orders')
    //   && (this.whs_IsWarehouseMenu_Flag == true || column.rowName != 'Inventory')
    // );
  }

  get filteredBooksOfAccountsMenuList(): any[] {
    return this.bookOfAccountsMenuList.filter(column => this.hasVisibleChildItems(column));
  }

  hasVisibleChildItems(column: any): boolean {
    for (let menu of column.childMenuList) {
      if (this.CheckHasRight(menu.rightcode, menu.screencode)) {
        return true;
      }
    }
    // for (let menu of column.childMenuList) {
    //   if (this.whs_IsWarehouseMenu_Flag != true && column.rowName == 'Reports') {
    //     if (menu.label == 'Operations' || menu.label == 'Inventory') {
    //       return false;
    //     }
    //   }
    //   if (this.CheckHasRight(menu.rightcode, menu.screencode)) {
    //     return true;
    //   }
    // }
    return false;
  }

  Get_whs_IsWarehouseMenu_Flag() {
    this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'whs_IsWarehouseMenu').subscribe((response) => {
      if (response[0].Value == "1") {
        localStorage.setItem("whs_IsWarehouseMenu_Flag", JSON.stringify(true));
        this.whs_IsWarehouseMenu_Flag = true;
      } else {
        localStorage.setItem("whs_IsWarehouseMenu_Flag", JSON.stringify(false));
        this.whs_IsWarehouseMenu_Flag = false;
      }
    },
      (err) => {
        console.log('err', err);
      });
  }
}
